module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gUAnN"))).then(() => module.bundle.root('fThBo'));